import { fork } from 'redux-saga/effects';
import auth from './auth';
import question from './question';
import global from './global';
import information from './information';
import userData from './user-data';
import year from './year';
import regist from './regist';
import order from './order';
import inquiry from './inquiry';
import exam from './exam';
import event from './event';

//importしたモジュールの数だけ forkする事。
export default function* rootSaga() {
  yield fork(auth);
  yield fork(question);
  yield fork(global);
  yield fork(information);
  yield fork(userData);
  yield fork(year);
  yield fork(regist);
  yield fork(order);
  yield fork(inquiry);
  yield fork(exam);
  yield fork(event);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js